"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contains_1 = require("./contains");
var splitParentNode_1 = require("./splitParentNode");
var toArray_1 = require("./toArray");
/**
 * Collapse nodes within the given start and end nodes to their common ascenstor node,
 * split parent nodes if necessary
 * @param root The root node of the scope
 * @param start The start node
 * @param end The end node
 * @param canSplitParent True to allow split parent node there are nodes before start or after end under the same parent
 * and the returned nodes will be all nodes from start trhough end after splitting
 * False to disallow split parent
 * @returns When cansplitParent is true, returns all node from start through end after splitting,
 * otherwise just return start and end
 */
function collapseNodes(root, start, end, canSplitParent) {
    if (!contains_1.default(root, start) || !contains_1.default(root, end)) {
        return [];
    }
    start = collapse(root, start, end, true /*isStart*/, canSplitParent);
    end = collapse(root, end, start, false /*isStart*/, canSplitParent);
    if (contains_1.default(start, end, true /*treateSameNodeAsContain*/)) {
        return [start];
    }
    else if (contains_1.default(end, start)) {
        return [end];
    }
    else if (start.parentNode == end.parentNode) {
        var nodes = toArray_1.default(start.parentNode.childNodes);
        var startIndex = nodes.indexOf(start);
        var endIndex = nodes.indexOf(end);
        return nodes.slice(startIndex, endIndex + 1);
    }
    else {
        return [start, end];
    }
}
exports.default = collapseNodes;
function collapse(root, node, ref, isStart, canSplitParent) {
    while (node.parentNode != root && !contains_1.default(node.parentNode, ref)) {
        if ((isStart && node.previousSibling) || (!isStart && node.nextSibling)) {
            if (!canSplitParent) {
                break;
            }
            splitParentNode_1.default(node, isStart);
        }
        node = node.parentNode;
    }
    return node;
}
//# sourceMappingURL=collapseNodes.js.map